import { render, staticRenderFns } from "./SummerPrepositionsPhone.vue?vue&type=template&id=ceb45d52&"
import script from "./SummerPrepositionsPhone.vue?vue&type=script&lang=js&"
export * from "./SummerPrepositionsPhone.vue?vue&type=script&lang=js&"
import style0 from "./SummerPrepositionsPhone.vue?vue&type=style&index=0&lang=scss&scope=app%2Fassets%2Fstylesheets%2Fcomponents%2Ftips-phone&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports